import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  selected: {},
  isLoaded: false,
};

const employeeSlice = createSlice({
  name: "employee",
  initialState,
  reducers: {
    setEmployeesProfile: (state, { payload }) => {
      state.profile = payload;
      console.log('[employeeSlice] Payload:', payload);
    },
    setEmployees: (state, { payload }) => {
      state.list = payload;
      state.isLoaded = true;
    },
    addEmployeeToList: (state, { payload }) => {
      state.list = { ...state.list, payload };
    },
    updateEmployeeList: (state, { payload }) => {
      state.list = state.list.map((item) =>
        item.id === payload.id ? payload : item
      );
    },
    removeEmployeeFromList: (state, { payload }) => {
      state.list = state.list.filter((item) => item.id !== payload);
    },
    clearEmployees: (state) => {
      state.list = [];
    },
    clearSelectedEmployee: (state) => {
      state.selected = {};
    },
    setSelectedEmployee: (state, { payload }) => {
      state.selected = payload;
    },
  },
});

export const {
  setEmployees,
  clearEmployees,
  clearSelectedEmployee,
  setSelectedEmployee,
  addEmployeeToList,
  updateEmployeeList,
  removeEmployeeFromList,
  setEmployeesProfile,
} = employeeSlice.actions;
export default employeeSlice.reducer;
